<span class="tag bg-success" *ngIf="state == discountState.ACTIVE">
  {{'state.active' | translate}}
</span>
<span class="tag bg-info" *ngIf="state == discountState.DRAFT">
  {{'state.draft' | translate}}
</span>
<span class="tag bg-warning" *ngIf="state == discountState.DELETED">
  {{'state.deleted' | translate}}
</span>